query getInventoryState($date: DateTime) {
	inventoryState(date: $date) {
		...fullInventoryState
	}
}